/**
 * /management page — migrated from public/js/management.js.
 * Single navMenu call pe submenu pentru a comuta intre plan panels.
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    ($('header .submenu') as Element | null)?.navMenu('a', '.layer-1 .plan');
});
